import { render, staticRenderFns } from "./Self.vue?vue&type=template&id=0bf32f56&scoped=true&"
import script from "./Self.vue?vue&type=script&lang=js&"
export * from "./Self.vue?vue&type=script&lang=js&"
import style0 from "./Self.vue?vue&type=style&index=0&id=0bf32f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf32f56",
  null
  
)

export default component.exports